document.addEventListener('DOMContentLoaded', function () {
  var stickyBars = document.querySelectorAll('[data-gigo-sticky-atc]');

  if (!stickyBars.length) return;

  stickyBars.forEach(function (stickyBar) {
    var sectionId = stickyBar.getAttribute('data-section-id');
    var addToCartText = stickyBar.getAttribute('data-add-to-cart-text') || 'Agregar al carrito';
    var soldOutText = stickyBar.getAttribute('data-sold-out-text') || 'Agotado';
    var mainButton = document.getElementById('ProductSubmitButton-' + sectionId);
    var productInfo = document.getElementById('ProductInfo-' + sectionId);
    var stickyButton = stickyBar.querySelector('[data-gigo-sticky-button]');
    var stickyVariant = stickyBar.querySelector('[data-gigo-sticky-variant]');

    if (!mainButton || !productInfo || !stickyButton) return;

    function cleanText(text) {
      return (text || '')
        .replace(/Variant sold out/gi, '')
        .replace(/Variant unavailable/gi, '')
        .replace(/Sold out/gi, '')
        .replace(/Variante agotada/gi, '')
        .replace(/Variante no disponible/gi, '')
        .replace(/Agotado/gi, '')
        .trim();
    }

    function getSelectedVariantText() {
      var selectedValues = [];

      productInfo.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
        var value = cleanText(input.value);

        if (value) {
          selectedValues.push(value);
        }
      });

      productInfo.querySelectorAll('select').forEach(function (select) {
        if (select.selectedIndex >= 0) {
          var value = cleanText(select.options[select.selectedIndex].text);

          if (value) {
            selectedValues.push(value);
          }
        }
      });

      selectedValues = selectedValues.filter(function (value) {
        return value && value.toLowerCase() !== 'default title';
      });

      selectedValues = selectedValues.filter(function (value, index, values) {
        return values.indexOf(value) === index;
      });

      return selectedValues.join(' / ');
    }

    function syncStickyState() {
      var mainButtonText = mainButton.querySelector('span');
      var text = mainButtonText ? cleanText(mainButtonText.textContent) : addToCartText;
      var isDisabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';

      stickyButton.disabled = isDisabled;
      stickyButton.textContent = text || (isDisabled ? soldOutText : addToCartText);

      if (stickyVariant) {
        var selectedText = getSelectedVariantText();
        stickyVariant.textContent = selectedText || '';
      }
    }

    function updateVisibility() {
      if (window.innerWidth > 749) {
        stickyBar.classList.remove('is-visible');
        stickyBar.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('gigo-sticky-atc-active');
        return;
      }

      var rect = mainButton.getBoundingClientRect();
      var shouldShow = rect.bottom < 0;

      stickyBar.classList.toggle('is-visible', shouldShow);
      stickyBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      document.body.classList.toggle('gigo-sticky-atc-active', shouldShow);
    }

    stickyButton.addEventListener('click', function () {
      syncStickyState();

      if (!stickyButton.disabled) {
        mainButton.click();
      }
    });

    productInfo.addEventListener('change', function () {
      setTimeout(function () {
        syncStickyState();
        updateVisibility();
      }, 150);
    });

    var observer = new MutationObserver(function () {
      syncStickyState();
    });

    observer.observe(mainButton, {
      attributes: true,
      childList: true,
      subtree: true
    });

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);

    syncStickyState();
    updateVisibility();
  });
});
